// Events for tracking Quiz interactions for Pop Quiz modal, based on implementation in Learner-Experience

import {ClientEvent} from '@udemy/event-tracking';

export class QuizStarted extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number} | null,
        public attemptId: number,
    ) {
        super('QuizStarted');
    }
}

export class QuizCompleted extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number} | null,
        public attemptId: number,
        public percentCorrect: number,
    ) {
        super('QuizCompleted');
    }
}

export class PopQuizPresented extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number},
    ) {
        super('PopQuizPresented');
    }
}

export class PopQuizSnoozed extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number},
        public snoozeDurationDays: number,
    ) {
        super('PopQuizSnoozed');
    }
}

export class PopQuizContinueCourseSelected extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number},
    ) {
        super('PopQuizContinueCourseSelected');
    }
}

export class PopQuizDismissed extends ClientEvent {
    constructor(
        public quiz: {id: number; numberOfQuestions: number},
        public course: {id: number},
    ) {
        super('PopQuizDismissed');
    }
}
